var _circle, _circle2, _circle3, _circle4, _circle5, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallingWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 31,
    fill: "#356966"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 30.5,
    stroke: "white",
    strokeOpacity: 0.16
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.0001,
    cy: 31.0005,
    r: 24.9722,
    fill: "#356966"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.0001,
    cy: 31.0005,
    r: 24.4722,
    stroke: "white",
    strokeOpacity: 0.41
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.9999,
    cy: 30.9999,
    r: 19.8056,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8319 31.0308C27.9848 33.2965 29.8382 35.15 32.1079 36.3028L33.8693 34.5375C34.0895 34.3173 34.4057 34.2533 34.6819 34.3413C35.5786 34.6376 36.5433 34.7977 37.5401 34.7977C37.9844 34.7977 38.3407 35.154 38.3407 35.5983V38.4005C38.3407 38.8448 37.9844 39.2011 37.5401 39.2011C30.0223 39.2011 23.9297 33.1084 23.9297 25.5907C23.9297 25.1463 24.29 24.79 24.7303 24.79H27.5324C27.9768 24.79 28.3331 25.1463 28.3331 25.5907C28.3331 26.5874 28.4932 27.5522 28.7894 28.4488C28.8775 28.725 28.8134 29.0413 28.5933 29.2615L26.8319 31.0308Z",
    fill: "#356966"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallingWhite);
export default __webpack_public_path__ + "static/media/calling_white.305efbf19ffc12f7d45eb1b3c9f26192.svg";
export { ForwardRef as ReactComponent };